export var AppUiSubjects;
(function (AppUiSubjects) {
    AppUiSubjects["ApplicationLayout"] = "application-layout";
    AppUiSubjects["HeaderAccountSelect"] = "header-account-select";
})(AppUiSubjects || (AppUiSubjects = {}));
/** Subjects for the app-ui sidenav. Distinct from `SidenavSubjects`, which targets the legacy app-frontend nav. */
export var AppUiSideNavSubjects;
(function (AppUiSideNavSubjects) {
    AppUiSideNavSubjects["MeetOrionIqCard"] = "sidenav-meet-orioniq-card";
    AppUiSideNavSubjects["MeetOrionIqCta"] = "sidenav-meet-orioniq-cta";
})(AppUiSideNavSubjects || (AppUiSideNavSubjects = {}));
//# sourceMappingURL=app-ui.enum.js.map